import React from 'react';
import { Button } from '@mui/material';
import Popover from '@mui/material/Popover';

const INPUT_TYPES = [
  { type: 'TEXT', label: 'Texto' },
  { type: 'EMAIL', label: 'Correo electrónico' },
  { type: 'DATE', label: 'Fecha' },
  { type: 'URL', label: 'URL' },
  { type: 'DATE_TIME', label: 'Fecha y hora' },
  { type: 'NUMBER', label: 'Número' },
  { type: 'UPLOAD_FILE', label: 'Adjuntar archivos' },
  { type: 'UPLOAD', label: 'Fotografía' },
  { type: 'DROPBOX', label: 'Opción (dropbox)' },
  { type: 'MULTI_DROPBOX', label: 'Opciones múltiples' },
  { type: 'SIGNATURE', label: 'Firma' },
  { type: 'REPEATABLE_SECTION', label: 'Sección repetible' },
  { type: 'GEOLOCATION', label: 'Geolocalización (GPS)' },
  { type: 'AUTONUMBER', label: 'Autonumeración (ID automático)' },
];

const InputTypeMenu = ({ 
  isOpen, 
  anchorEl, 
  onClose, 
  onSelectType 
}) => {
  const buttonStyle = {
    WebkitJustifyContent: 'flex-start',
    justifyContent: 'flex-start',
    color: 'black'
  };

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div className="input-options" style={{ display: 'flex', flexDirection: 'column', padding: '8px' }}>
        {INPUT_TYPES.map(({ type, label }) => (
          <Button
            key={type}
            style={buttonStyle}
            onClick={() => {
              onSelectType(type);
              onClose();
            }}
          >
            {label}
          </Button>
        ))}
      </div>
    </Popover>
  );
};

export default InputTypeMenu;
